import * as R from 'ramda';
import { format } from 'date-fns';
import { OLD_STATUS_CHIP } from './components/OldStatusChip';
import { STATUS_CHIP } from './components/StatusChip';

// formatDate :: String -> String
export const formatDate = date => format(new Date(date), 'MMMM d, yyyy');

// isEditableStatus :: Status -> Bool
export const isEditableStatus = R.includes(R.__, [
  'Unconfirmed',
  'Cannot Book',
  'Scheduled',
  'Needs Attention',
  'Processing',
]);

// prettier-ignore
// isOptionEqualToValue :: String -> (a -> a) -> Bool
export const isOptionEqualToValue = prop => (option, value) => R.equals(
    R.propOr({}, prop, option), 
    R.propOr({}, prop, value)
);

export const shipmentStatusTooltips = {
  [STATUS_CHIP.CANCELED]: 'Shipment is canceled.',
  [STATUS_CHIP.CANNOT_BOOK]:
    'Shipment needs attention to move to Scheduled status. Review Shipment Details for more information or contact ONEOK Shipper Service for assistance.',
  [STATUS_CHIP.EXPIRED]: 'Shipment is expired.',
  [STATUS_CHIP.OPEN]: 'Shipment is pumping and in transit.',
  [STATUS_CHIP.SCHEDULED]: 'Shipment is tentative or accepted, but not yet shipped.',
  [STATUS_CHIP.CLOSED]: 'Shipment has finished pumping, the ticket is closed or net.',
  [OLD_STATUS_CHIP.UNCONFIRMED]: 'The shipment needs to be accepted by the shipper.',
  [STATUS_CHIP.NEEDS_ATTENTION]:
    'Shipment needs attention to move to Scheduled status. Review Shipment Details for more information.',
};

// isReConsignmentEditableStatus :: Status -> Bool
export const isReConsignmentEditableStatus = R.includes(R.__, ['CANNOT BOOK', 'SCHEDULED']);
export const batchStatusTooltips = {
  [STATUS_CHIP.CANCELED]: 'Batch is canceled.',
  [STATUS_CHIP.CANNOT_BOOK]:
    'Batch needs attention to move to Scheduled status. Review Batch Details for more information or contact ONEOK Shipper Services for immediate assistance.',
  [STATUS_CHIP.EXPIRED]: 'Batch is expired.',
  [STATUS_CHIP.OPEN]: 'Shipment is pumping and in transit.',
  [STATUS_CHIP.NEEDS_ATTENTION]:
    'Batch needs attention to move to Scheduled status. Review Batch Details for more information.',
  [STATUS_CHIP.SCHEDULED]: 'Batch is tentative or accepted, but not yet shipped.',
  [STATUS_CHIP.CLOSED]: 'Shipment(s) finished pumping; the ticket is closed or net.',
  [STATUS_CHIP.UNCONFIRMED]:
    'One or more of the shipments or distributions on the batch are unconfirmed.',
};

export const distributionStatusTooltips = {
  [STATUS_CHIP.CANCELED]: 'Distribution is canceled.',
  [STATUS_CHIP.CANNOT_BOOK]:
    'Distribution needs attention to move to Scheduled status. Review Distribution Details for more information or contact ONEOK Shipper Service for assistance.',
  [STATUS_CHIP.EXPIRED]: 'Distribution was not accepted and is expired.',
  [STATUS_CHIP.OPEN]: 'Shipment is pumping and in transit.',
  [STATUS_CHIP.NEEDS_ATTENTION]:
    'Distribution needs attention to move to Scheduled status. Review Distribution Details for more information.',
  [STATUS_CHIP.SCHEDULED]: 'Distribution is tentative or accepted, but not yet shipped.',
  [STATUS_CHIP.CLOSED]: 'Distribution finished pumping; the ticket is closed or net.',
  [STATUS_CHIP.UNCONFIRMED]: 'The Distribution needs to be accepted by the Inventory Owner.',
};
